import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
}

export default function EmailField({ register, errors }: Props) {
  return (
    <div className="form-row">
      <label className="form-label">Adres - email*</label>
      <input type="email" className="form-input" {...register('email')} />
      {errors.email && <div className="form-error">{errors.email.message}</div>}
    </div>
  );
}
